import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export type Mentor = {
	id: string;
	name: string;
	image: string;
};

export async function fetchAdminMentors(): Promise<
	| {
			status: "success";
			data: Mentor[];
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get("/mentor");

		return {
			status: "success",
			data: data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
